import { render, staticRenderFns } from "./addtaskpersonnel.vue?vue&type=template&id=1a5f4cac&scoped=true&"
import script from "./addtaskpersonnel.vue?vue&type=script&lang=js&"
export * from "./addtaskpersonnel.vue?vue&type=script&lang=js&"
import style0 from "./addtaskpersonnel.vue?vue&type=style&index=0&id=1a5f4cac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f4cac",
  null
  
)

export default component.exports